
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-1 -1 37 37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"18","cy":"17","r":"17","fill":"#D2D5D9"}}),_c('path',{staticClass:"black-fill",attrs:{"d":"M34.9 17.368c-2.278.142-4.556.142-6.691.427-1.424.142-2.99.427-4.271.996-2.563 1.14-4.128 2.99-4.84 5.694-.427 1.709-.57 3.417-.712 5.125-.142 1.566-.142 3.275-.142 4.84h-.427l-.427-7.26c-.143-1.423-.428-2.847-1.14-4.128-1.138-2.278-2.989-3.844-5.551-4.413-1.709-.427-3.275-.57-4.983-.712-1.566-.142-3.274-.142-4.84-.142v-.427l7.26-.427c1.424-.143 2.847-.427 4.129-1.14 2.277-1.138 3.7-2.989 4.413-5.409.427-1.708.57-3.416.712-5.125.142-1.566.142-3.274.142-4.84h.427l.427 7.26c.142 1.424.427 2.847 1.139 4.129 1.139 2.277 2.99 3.843 5.552 4.413 1.85.57 3.843.712 5.836.712 1.424 0 2.705.142 4.129.142-.142-.142-.142.142-.142.285z","fill":"#fff"}})])
          )
        }
      }
    